/**
 * Axios request interceptor — injects the Bearer token.
 *
 * Reads the current access token from `localStorage` and appends an
 * `Authorization: Bearer <token>` header to every outgoing request,
 * **except** for authentication endpoints that do not require a token:
 * - `/auth/session`
 * - `/oauth/token`
 */
import axios from "./instance";

import { getAccessToken } from "@service/local-storage-handler";
axios.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();
    if (
      accessToken &&
      !(
        config.url.includes("auth/session") ||
        config.url.includes("oauth/token")
      )
    ) {
      config.headers["Authorization"] = "Bearer " + accessToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
